import React from 'react';
import partiallyApplyComponent from './partiallyApplyComponent';

const hocify = <T>(Component: React.ComponentType<T>, partialProps: any) => (
  ComponentProp: React.ComponentType
) => {
  return partiallyApplyComponent(Component, {
    ...(partialProps || {}),
    Component: ComponentProp,
  });
};

export default hocify;
